import type {AxiosInstance} from "axios";
import type {MetlApiExport} from "../../metl-models/exports/MetlApiExport.ts";

export interface ListEndpoint<TChildApi, TExport = any> {
    list(): Promise<string[]>
    get(name: string): TChildApi
    exportAll(): Promise<MetlApiExport<TExport>>
    export(name: string): Promise<MetlApiExport<TExport>>
}

export interface IdListEndpoint<TChildApi, TExport = any> {
    list(): Promise<number[]>
    get(id: number): TChildApi
    exportAll(): Promise<MetlApiExport<TExport>>
    export(id: number): Promise<MetlApiExport<TExport>>
}


/**
 * Produce an endpoint for a standard metl provider service
 */
export function listEndpoint<TChildApi, TExport = any>(
    axios: AxiosInstance,
    baseUrl: string,
    /** this should be a unique id for the list api */
    id: string,
    childGetter: (axios: AxiosInstance, newBaseUrl: string, id: string) => TChildApi
): ListEndpoint<TChildApi, TExport> {
    return {
        list: async () => {
            const response = await axios.get<string[]>(baseUrl)
            return response.data
        },
        get: (name: string) => childGetter(axios, `${baseUrl}/name/${encodeURIComponent(name)}`, `${id}/${name}`),
        exportAll: async () => {
            const response = await axios.get<MetlApiExport<TExport>>(`${baseUrl}/export`)
            return response.data
        },
        export: async (name: string) => {
            const response = await axios.get<MetlApiExport<TExport>>(`${baseUrl}/name/${encodeURIComponent(name)}/export`)
            return response.data
        }
    }
}

/**
 * Produce an endpoint for a standard metl provider service which returns ids (e.g. shared job revisions)
 */
export function idListEndpoint<TChildApi, TExport = any>(
    axios: AxiosInstance,
    baseUrl: string,
    /** this should be a unique id for the list api */
    myId: string,
    childGetter: (axios: AxiosInstance, newBaseUrl: string, id: string) => TChildApi
): IdListEndpoint<TChildApi, TExport> {
    return {
        list: async () => {
            const response = await axios.get<number[]>(baseUrl)
            return response.data
        },
        get: (id: number) => childGetter(axios, `${baseUrl}/id/${encodeURIComponent(id)}`, `${myId}/${id}`),
        exportAll: async () => {
            const response = await axios.get<MetlApiExport<TExport>>(`${baseUrl}/export`)
            return response.data
        },
        export: async (id: number) => {
            const response = await axios.get<MetlApiExport<TExport>>(`${baseUrl}/id/${encodeURIComponent(id)}/export`)
            return response.data
        }
    }
}